/* eslint no-restricted-globals: [2, "find"] */

import isString from 'lodash/isString';

import status from '../status.json';
import config from '../config';
import HTTPError from './HTTPError';

const throwOnError = (response) => {
  if (response.status >= 400) {
    throw new HTTPError(response);
  }
  return response;
};

const clientHeaderValue = `WebCarriers/${status.version}.0`;

const getFetchedJSON = (response) => response.json();

const fetchWithStateSpecial = (getState, {url, body, method, headerMsg}, skipToken) => {
  const string = isString(body);
  let headers = {
    client: clientHeaderValue,
  };
  if (method !== 'GET' && method !== 'DELETE') {
    headers['Content-Type'] = string ? 'application/x-www-form-urlencoded' : 'application/json';
  }

  const state = getState();
  const token = state.user.token;
  if (!skipToken && token) {
    headers['x-auth-token'] = token;
  }

  const email = state.user.email;
  if (email && headerMsg.email) {
    headers.Email = email;
  }
  const accountEmail = state.account.userInfo.data ? state.account.userInfo.data.accountEmail : null;
  if (accountEmail && headerMsg.accountEmail) {
    headers.accountEmail = accountEmail;
  }

  return window.fetch(`${config.apiHost}${url}`, {
    method,
    headers,
    mode: 'cors',
    body: string ? body : JSON.stringify(body),
  }).then(throwOnError);
};

const fetchWithStateBase = (getState, {url, body, method = 'GET', header = {}}, {skipToken = false, withFile = false, prefix = config.apiHost, skipInstall = false}) => {
  const string = isString(body);
  let headers = {
    ...header,
    client: clientHeaderValue,
  };
  if (method !== 'GET' && method !== 'DELETE' && !withFile ) {
    headers['Content-Type'] = string ? 'application/x-www-form-urlencoded' : 'application/json';
  }
  const state = getState();
  const token = state.user.token;
  if (!skipToken && token) {
    headers['x-auth-token'] = token;
  }

  if(!skipInstall) {
    const id = state.installation.id;
    if (id) {
      headers['Installation-ID'] = id;
    } else {
      // 测试
      // headers['Installation-ID'] = '20c8da9d-e67a-a090-9d48-711c6d4d2434';
      // 生产
      headers['Installation-ID'] = 'b41367ef-0a0b-4171-81d8-942fcdbbdeec';
    }
  }
  

  return window.fetch(`${prefix}${url}`, {
    method,
    headers,
    mode: 'cors',
    body: string ? body : withFile ? body : JSON.stringify(body),
  }).then(throwOnError);
};

const fetchWithState = (getState, configs, skipToken) => fetchWithStateBase(getState, configs, { skipToken });
const fetchWithStateAndFile = (getState, configs, skipToken) => fetchWithStateBase(getState, configs, { skipToken, withFile:true });
const fetchWithMessage = (getState, configs, skipToken) => fetchWithStateBase(getState, configs, { skipToken, prefix: config.apiMessage});
const fetchWithStateBjorn = (getState, configs, skipToken) => fetchWithStateBase(getState, configs, { skipToken, prefix: config.apiBjorn});
const fetchWithStateBjornAndFile = (getState, configs, skipToken) => fetchWithStateBase(getState, configs, { skipToken, prefix: config.apiBjorn, withFile: true});
const fetchWithHere = (getState, configs) => fetchWithStateBase(getState, configs, { skipToken: true, skipInstall: true, prefix: config.apiHere});
const fetchWithNothing = ({url, body, method = 'GET', header = {}}) => {
  const string = isString(body);
  let headers = {
    ...header,
    client: clientHeaderValue,
  };
  headers['Content-Type'] = 'application/json';
  // 测试
  headers['Installation-ID'] = '20c8da9d-e67a-a090-9d48-711c6d4d2434';
  // 生产
  // headers['Installation-ID'] = 'b41367ef-0a0b-4171-81d8-942fcdbbdeec';

  return window.fetch(`${config.apiHost}${url}`, {
    method,
    headers,
    mode: 'cors',
    body: string ? body : JSON.stringify(body),
  }).then(throwOnError);
};

const fetchWithStateTL = (getState, {url, body, method = 'GET', header}, skipToken) => {
  const string = isString(body);
  let headers = {
    ...header,
    client: clientHeaderValue,
  };

  if (method !== 'GET' && method !== 'DELETE') {
    headers['Content-Type'] = string ? 'application/x-www-form-urlencoded; charset=utf-8' : 'application/json; charset=utf-8';
  }

  const state = getState();
  const token = state.user.token;
  if (!skipToken && token) {
    headers['x-auth-token'] = token;
  }

  const id = state.installation.id;
  if (id) {
    headers['Installation-ID'] = id;
  }
  return window.fetch(`${config.apiHostTL}${url}`, {
    method,
    headers,
    mode: 'cors',
    body: string ? body : JSON.stringify(body),
  }).then(throwOnError);
};

const fetchWithStateWithFixedToken = (getState, {url, body, method = 'GET', header}, fixedToken) => {
  const string = isString(body);
  let headers = {
    ...header,
    client: clientHeaderValue,
  };

  if (method !== 'GET' && method !== 'DELETE') {
    headers['Content-Type'] = string ? 'application/x-www-form-urlencoded' : 'application/json';
  }
  const state = getState();
  if (fixedToken) {
    headers['x-auth-token'] = fixedToken;
  }

  const id = state.installation.id;
  if (id) {
    headers['Installation-ID'] = id;
  }
  return window.fetch(`${config.apiHostTL}${url}`, {
    method,
    headers,
    mode: 'cors',
    body: string ? body : JSON.stringify(body),
  }).then(throwOnError);
};



export {
  getFetchedJSON,
  throwOnError,
  fetchWithState,
  fetchWithStateSpecial,
  fetchWithStateTL,
  fetchWithStateWithFixedToken,
  fetchWithNothing,
  fetchWithStateBjorn,
  fetchWithStateBjornAndFile,
  fetchWithStateAndFile,
  fetchWithHere,
  fetchWithMessage
};




// WEBPACK FOOTER //
// ./src/misc/fetch.js